//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        linkguid: {
            type: String,
            default: ''
        },
        orderid: {
            type: String,
            default: '',
        },
        invoiceInfo:{
            type:Object,
            default:()=>({}),
        }
    },
    data () {
        return {
            form: {
                linkguid: '',
                orderid: '',
                json: []
            },
        }
    },
    methods: {
        getGuid(cb) {
            this.$get(this.getStore('fileUrl') + "/getguid", {}, function (data, res) {
				cb && cb(data)
			});
        },
        submitHandler() {
            // 直接修改原数据会导致数据类型异常
            // this.form.json = JSON.stringify(this.form.json);
            let new_obj = {
                rowguid: this.form.linkguid,
                orderId: this.form.orderid,
                json: JSON.stringify(this.form.json),
                entName:this.invoiceInfo.entName,
                entCode:this.invoiceInfo.entCode,
                entAddress:this.invoiceInfo.entAddress,
                entPhone:this.invoiceInfo.entPhone,
                entBankName:this.invoiceInfo.entBankName,
                entBankCode:this.invoiceInfo.entBankCode,
            } 
            this.$post(this.getStore('finUrl') + '/receipt/kzzfp', new_obj, (data, res) => {
                ShowMsg.call(this, res.msg);
                this.$emit('close');
            });

        },
        tableDataTest(rule, value, callback) {
            if(this.form.json.some(item =>
                (!item.fp_hm || !item.kprq ))
            ) {
                return callback(new Error('发票列表中存在空项，请填写'))
            };
            callback();
        },
        fpCalcRow(row) {
            // if(isNaN(row.fp_jshj)){
            //     row.fp_jshj = 0;
            //     ShowMsg.call(this,"只能输入数字!",'error');
            // }else{
            //     row.fp_je = (Number(row.fp_jshj) / 1).toFixed(2);
            //     row.fp_se = (Number(row.fp_jshj) / 1 * 0).toFixed(2);
            // }

            // row.fp_je = (Number(row.fp_jshj) / 1.01).toFixed(2);
            row.fp_se = (Number(row.fp_jshj) / 1.01 * 0.01).toFixed(2);
            row.fp_je = Number(row.fp_jshj) - row.fp_se;
           
        },
        addRow() {
            this.getGuid(fileguid => {
                this.form.json.push({
                    fp_hm: '',
                    kprq: '',
                    fp_jshj: '0',
                    fp_je: '0',
                    fp_se: '0',
                    fp_bz: '',
                    fileguid: fileguid
                });
            });
        },
        delRow(index) {
            this.form.json.splice(index, 1);
        }
    },
    mounted: function() {
        this.$get(this.getStore('finUrl') + '/receipt/detail', {
            rowguid: this.linkguid
        }, (data, res) => {
            this.form.json = data;

            if(data.length == 0) {
                this.addRow();
            };
        });

        this.form.linkguid = this.linkguid; //实际是rowguid
        this.form.orderid = this.orderid;
    }
}
